<template>
  <div class="pages-about-processing-of-personal-data">
    <BundlesPage />
  </div>
</template>

<style scoped lang="scss">
.pages-about-processing-of-personal-data {
  padding-top: em($gap-page-title);
  padding-bottom: em(143);

  @include media-breakpoint-down(sm) {
    padding-top: em($gap-page-title-sm);
    padding-bottom: em(62);
  }

  @include bundles-constructor-section {
    &:nth-child(n + 2):not(:last-child) {
      margin-bottom: em(106);

      @include media-breakpoint-down(sm) {
        margin-bottom: em(65);
      }
    }
  }
}
</style>
